import { ArrowRight } from 'lucide-react';

import { SectionWrapper } from '../components/SectionWrapper';

import aiClassroomUrl from '@/images/ai_classroom.webp';
import styles from './AIUCLAStorySection.module.css';

export function AIUCLAStorySection() {
  return (
    <SectionWrapper background="soft" data-testid="ai-section-ucla-story">
      <div className={styles.section}>
        <div className={styles.copy}>
          <p className={styles.eyebrow}>A REAL CLASSROOM</p>
          <h2 className={styles.title}>
            Instead of banning AI, this UCLA literature class embraced it.
          </h2>
          <p className={styles.body}>
            When AI showed up on campus, most humanities classes responded with
            prohibition. Professor Zrinka Stahuljak&apos;s comparative
            literature class at UCLA went the other direction, building a
            course where AI is a tool students learn to use thoughtfully rather
            than something to avoid.
          </p>
          <p className={styles.body}>
            The course&apos;s textbook, discussion guides, and homework were
            all built using Kudu&apos;s AI authoring system, with
            Stahuljak&apos;s materials and judgment as ground truth. The
            classroom AI tutor is grounded in the same content. Students learn
            the literature and learn to interrogate AI&apos;s relationship to it.
            The course made the front page of LAist.
          </p>
          <blockquote className={styles.quote}>
            <span className={styles.quoteText}>
              &quot;Instead of banning AI, this UCLA literature class embraces
              it.&quot;
            </span>
            <span className={styles.quoteSource}>LAist, February 2025</span>
          </blockquote>
          <a
            className={styles.link}
            href="https://laist.com/news/education/ucla-humanities-courses-artificial-intelligence-chatgpt-kudu"
            rel="noreferrer"
            target="_blank"
          >
            Read the full story <ArrowRight aria-hidden="true" size={14} />
          </a>
        </div>

        <img
          alt="Professor Zrinka Stahuljak's comparative literature classroom at UCLA."
          className={styles.image}
          loading="lazy"
          src={aiClassroomUrl}
        />
      </div>
    </SectionWrapper>
  );
}
